import IdentityObject from "@/src/domain/common/identity-object";

export default abstract class AuthService extends IdentityObject {
  abstract login(email: string, password: string, rememberMe?: boolean): Promise<void>;

  abstract logout(): Promise<void>;

  /**
   * @throws {RegisterError} when the registration fails
   */
  abstract register(email: string, password: string, serialNumber: string): Promise<void>;

  abstract get status(): AuthenticationStatus;

  abstract setStatus(status: AuthenticationStatus): void;
}

export enum AuthenticationStatus {
  Idle,
  Authenticating,
  RequestUserInfo,
  FetchingUserInfo,
  Authenticated,
  NotAuthenticated,
  Error,
}
